import http from '../../../services/http'

export default {
    create: (d) => http.post('docs', d),
    update: (id, d) => http.put('docs/' + id, d),
    updateContent: (id, d) => http.put('docs/' + id + '/content', d),
    delete: (id) => http.delete('docs/' + id),
    getContent: (id) => http.get('docs/' + id)
}